module.exports = __webpack_public_path__ + "img/hkqaa-hkregistration.fb477c25.jpg";